const bookedKey = "bookedKey";
const amountKey = "amountKey";
const bookedNowKey = "bookedNowKey";
const PRIVATE_KEY = "iaWF0Ijox";
import { AES, enc } from "crypto-js";

export function encrypt(data) {
  const encode = AES.encrypt(JSON.stringify(data), PRIVATE_KEY);
  return encode.toString();
}

export function decrypt(cipherText) {
  try {
    const bytes = AES.decrypt(cipherText, PRIVATE_KEY);
    return JSON.parse(bytes.toString(enc.Utf8));
  } catch (error) {
    return cipherText;
  }
}

export function setInfoBooked(data) {
  data = encrypt(data);
  return localStorage.setItem(bookedKey, data);
}

export function getInfoBooked() {
  let booked = localStorage.getItem(bookedKey);
  if (booked) {
    booked = decrypt(booked);
    return booked;
  }
  return null;
}

export function removeInfoBooked() {
  return localStorage.removeItem(bookedKey);
}

export function setInfoBookedNow(data) {
  data = encrypt(data);
  return localStorage.setItem(bookedNowKey, data);
}

export function getInfoBookedNow() {
  let booked = localStorage.getItem(bookedNowKey);
  if (booked) {
    booked = decrypt(booked);
    return booked;
  }
  return null;
}

export function removeInfoBookedNow() {
  return localStorage.removeItem(bookedNowKey);
}

export function setDepositAmount(data) {
  return localStorage.setItem(amountKey, data);
}
export function removeDepositAmount() {
  return localStorage.removeItem(amountKey);
}
export function getDepositAmount() {
  if (localStorage.getItem(amountKey)) return localStorage.getItem(amountKey);
}
